import type { FloorBay } from "building-types/floors/floorSplitDataTypes";
import type {
  SplitLineJoistAlignment,
  SplitLineSupportFramingCondition,
} from "building-types/floors/floorSplitDataTypes";
import type { ForeignEntityId } from "building-types/handles/foreignEntityId";
import type { PolyLine2 } from "geom/polyLine2Types";

export enum ConstraintLineType {
  SUPPORT_LINE = "SUPPORT_LINE", // Framing may pass over these lines
  FRAMING_LINE = "FRAMING_LINE", // Framing terminates at the line from one or both sides
}

export interface ConstraintLine {
  readonly type: ConstraintLineType;
  readonly polyline: PolyLine2;
  readonly width: number; // Width for framing termination and offsets
  readonly joistAlignment?: SplitLineJoistAlignment;
  readonly supportFramingCondition?: SplitLineSupportFramingCondition;
  readonly framingComponentId?: ForeignEntityId<"FRAMING_COMPONENT">;
  readonly spliceLength?: number;
  readonly bayId?: FloorBay["id"];
  readonly bayLeftId?: FloorBay["id"];
  readonly bayRightId?: FloorBay["id"];
}

export interface SegmentConstraintIntersection {
  readonly x: number;
  readonly y: number;
  readonly t: number;
  readonly constraintEdgeIndex: number;
}
